var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['section-container', _vm.classes],style:(_vm.cssVars),attrs:{"data-section":_vm.sectionId}},_vm._l((_vm.getFields),function(field){return _c('component-renderer',{key:field.id,class:`col-lg-${_vm.getColumns(field)} component-wrapper`,attrs:{"sectionId":_vm.sectionId,"field":field},on:{"component-updated":_vm.updated}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }